import { type SelectChangeEvent } from '@ltvco/refresh-lib/theme';
import { ExpandMore } from '@mui/icons-material';
import React from 'react';

import {
  DropdownContainer,
  StyledFormControl,
  StyledSelect,
  StyledMenuItem,
} from './components';

export interface SortOption {
  value: string;
  display: string;
}

export interface SortByDropdownProps {
  value: string;
  options: SortOption[];
  onChange: (value: string) => void;
  label?: string;
  id?: string;
  defaultValue?: string;
}

export const SortByDropdown: React.FC<SortByDropdownProps> = ({
  value,
  options,
  onChange,
  label = 'Sort By',
  id = 'sort-by-dropdown',
  defaultValue = 'score_desc',
}) => {
  // Use provided value or fallback to default
  const effectiveValue = value || defaultValue;

  // Find the display text for the current value
  const selectedOption = options.find((opt) => opt.value === effectiveValue);
  const displayText = selectedOption
    ? `${label}: ${selectedOption.display}`
    : label;

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event.target.value as string);
  };

  return (
    <DropdownContainer>
      <StyledFormControl size="small">
        <StyledSelect
          id={id}
          value={effectiveValue}
          onChange={handleChange}
          IconComponent={ExpandMore}
          displayEmpty
          renderValue={() => displayText}
        >
          {options.map((option) => (
            <StyledMenuItem key={option.value} value={option.value}>
              {option.display}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </DropdownContainer>
  );
};
